import React, { useState, useEffect } from 'react';

const StickyCTA = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => setVisible(window.scrollY > 500);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (!visible) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: '24px',
            right: '24px',
            zIndex: 40
        }}>
            <a
                href="#contact"
                className="btn-primary"
                style={{
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)'
                }}
            >
                <i className="fas fa-comments"></i> Let's Talk
            </a>
        </div>
    );
};

export default StickyCTA;